const DashboardIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.61928 15.979C3.10732 14.7432 2.90806 13.4003 3.03915 12.0691C3.17025 10.7379 3.62764 9.45958 4.37082 8.34738C5.114 7.23518 6.12002 6.32342 7.29978 5.69286C8.47953 5.06231 9.7966 4.73242 11.1343 4.73242C11.3431 4.73242 11.5433 4.81535 11.6909 4.96297C11.8386 5.11058 11.9215 5.3108 11.9215 5.51956V12.1266C11.9215 12.3918 12.0269 12.6462 12.2144 12.8337L16.8861 17.505C17.0335 17.6526 17.1163 17.8526 17.1163 18.0612C17.1163 18.2698 17.0335 18.4699 16.8861 18.6175C15.9402 19.5633 14.7756 20.2612 13.4956 20.6495C12.2155 21.0378 10.8595 21.1044 9.54749 20.8435C8.23552 20.5826 7.00816 20.0022 5.97411 19.1537C4.94005 18.3051 4.13123 17.2147 3.61928 15.979Z"
        fill="currentColor"
      />
      <path
        opacity="0.55"
        d="M14.0196 3C13.8108 3 13.6106 3.08293 13.463 3.23055C13.3154 3.37816 13.2324 3.57837 13.2324 3.78713V10.3571C13.2324 10.7926 13.5851 11.1442 14.0196 11.1442H20.59C20.7988 11.1442 20.999 11.0613 21.1467 10.9137C21.2943 10.7661 21.3772 10.5658 21.3772 10.3571C21.3772 9.39094 21.1869 8.43425 20.8171 7.54165C20.4474 6.64905 19.9054 5.83801 19.2222 5.15484C18.539 4.47167 17.7279 3.92975 16.8352 3.56003C15.9426 3.1903 14.9858 3 14.0196 3Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8588 12.373C21.4807 12.373 22.0505 12.889 21.9883 13.5835C21.9289 14.2466 21.7686 14.8979 21.5138 15.5154V15.5175C21.2572 16.1343 20.9086 16.708 20.4816 17.2188C20.0344 17.7533 19.2669 17.7158 18.8273 17.2762L15.536 13.9852C14.9414 13.3903 15.3631 12.3734 16.2043 12.373H20.8588Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DashboardIcon;
